(function () {
/* eslint-disable no-shadow */ "use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


"use strict";
var $3d28d7f1aac198f5$var$SIZE_BOARD = 4;
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.board = initialState ? this.cloneBoard(initialState) : this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this, _loop = function(row) {
                    var newRow = _this.board[row].filter(function(cell) {
                        return cell !== 0;
                    });
                    var merged = new Array(newRow.length).fill(false);
                    for(var i = 0; i < newRow.length - 1; i++)if (newRow[i] === newRow[i + 1] && !merged[i] && !merged[i + 1]) {
                        newRow[i] *= 2;
                        _this.score += newRow[i];
                        newRow.splice(i + 1, 1);
                        merged[i] = true;
                        moved = true;
                    }
                    while(newRow.length < $3d28d7f1aac198f5$var$SIZE_BOARD)newRow.push(0);
                    if (_this.board[row].some(function(cell, idx) {
                        return cell !== newRow[idx];
                    })) {
                        moved = true;
                        _this.board[row] = newRow;
                    }
                };
                if (this.status !== "playing") return false;
                var moved = false;
                for(var row = 0; row < $3d28d7f1aac198f5$var$SIZE_BOARD; row++)_loop(row);
                if (moved) {
                    this.addRandomBox();
                    if (this.checkWin()) return true;
                    if (!this.hasEmptuCellsCantMove()) this.status = "lose";
                }
                return moved;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                this.board = this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
                var moved = this.moveLeft();
                this.board = this.board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
                return moved;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transpose();
                var moved = this.moveLeft();
                this.transpose();
                return moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transpose();
                var moved = this.moveRight();
                this.transpose();
                return moved;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                if (this.status === "idle") return "idle";
                for(var row = 0; row < $3d28d7f1aac198f5$var$SIZE_BOARD; row++)for(var col = 0; col < $3d28d7f1aac198f5$var$SIZE_BOARD; col++){
                    if (this.board[row][col] === 2048) return "win";
                }
                if (!this.hasEmptuCellsCantMove()) {
                    this.status = "lose";
                    return "lose";
                }
                return "playing";
            }
        },
        {
            key: "start",
            value: function start() {
                if (this.status !== "idle") return;
                this.status = "playing";
                this.addRandomBox();
                this.addRandomBox();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = this.createEmptyBoard();
                this.score = 0;
                this.status = "playing";
                this.addRandomBox();
                this.addRandomBox();
            }
        },
        {
            key: "cloneBoard",
            value: function cloneBoard(board) {
                return board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                return Array.from({
                    length: $3d28d7f1aac198f5$var$SIZE_BOARD
                }, function() {
                    return Array(4).fill(0);
                });
            }
        },
        {
            key: "addRandomBox",
            value: function addRandomBox() {
                var emptyCells = [];
                for(var row = 0; row < $3d28d7f1aac198f5$var$SIZE_BOARD; row++){
                    for(var col = 0; col < $3d28d7f1aac198f5$var$SIZE_BOARD; col++)if (this.board[row][col] === 0) emptyCells.push({
                        row: row,
                        col: col
                    });
                }
                if (emptyCells.length > 0) {
                    var _emptyCells_Math_floor = emptyCells[Math.floor(Math.random() * emptyCells.length)], row1 = _emptyCells_Math_floor.row, col1 = _emptyCells_Math_floor.col;
                    this.board[row1][col1] = Math.random() < 0.9 ? 2 : 4;
                }
            }
        },
        {
            key: "hasEmptuCellsCantMove",
            value: function hasEmptuCellsCantMove() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$SIZE_BOARD; row++)for(var col = 0; col < $3d28d7f1aac198f5$var$SIZE_BOARD; col++){
                    if (this.board[row][col] === 0) return true;
                }
                for(var row1 = 0; row1 < $3d28d7f1aac198f5$var$SIZE_BOARD; row1++)for(var col1 = 0; col1 < $3d28d7f1aac198f5$var$SIZE_BOARD; col1++){
                    if (col1 < 3 && this.board[row1][col1] === this.board[row1][col1 + 1]) return true;
                    if (row1 < 3 && this.board[row1][col1] === this.board[row1 + 1][col1]) return true;
                }
                return false;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var row = 0; row < $3d28d7f1aac198f5$var$SIZE_BOARD; row++){
                    for(var col = 0; col < $3d28d7f1aac198f5$var$SIZE_BOARD; col++)if (this.board[row][col] === 2048) {
                        this.status = "win";
                        return true;
                    }
                }
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                this.board = this.board[0].map(function(_, col) {
                    return(// eslint-disable-next-line comma-dangle
                    _this.board.map(function(row) {
                        return row[col];
                    }));
                });
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$startButton = document.querySelector(".button");
var $197cd56b15c33885$var$gameField = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
$197cd56b15c33885$var$startButton.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.remove("restart");
        $197cd56b15c33885$var$startButton.classList.add("start");
    }
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateMessage();
});
function $197cd56b15c33885$var$updateBoard() {
    var board = $197cd56b15c33885$var$game.getState();
    $197cd56b15c33885$var$gameField.forEach(function(cell, index) {
        var row = Math.floor(index / 4);
        var col = index % 4;
        var value = board[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    });
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateMessage() {
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    var nowStatus = $197cd56b15c33885$var$game.getStatus();
    if (nowStatus === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
    else if (nowStatus === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (nowStatus === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
}
document.addEventListener("keydown", function(event) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var moved = false;
    switch(event.key){
        case "ArrowLeft":
        case "a":
        case "A":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
        case "d":
        case "D":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
        case "w":
        case "W":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
        case "s":
        case "S":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if (moved) {
        $197cd56b15c33885$var$updateBoard();
        $197cd56b15c33885$var$updateMessage();
        if ($197cd56b15c33885$var$game.getStatus() !== "idle" && $197cd56b15c33885$var$startButton.textContent !== "Restart") {
            $197cd56b15c33885$var$startButton.textContent = "Restart";
            $197cd56b15c33885$var$startButton.classList.remove("start");
            $197cd56b15c33885$var$startButton.classList.add("restart");
        }
    }
});
$197cd56b15c33885$var$updateBoard();
$197cd56b15c33885$var$updateMessage();

})();
//# sourceMappingURL=index.2a44d30c.js.map
